import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'react-tooltip';
import { css } from '/imports/ui/css';
import { ProjectManagementProject, ProjectManagementProjectStatus, projectManagementProjectStatus, projectStatusLabel } from '/imports/api/projectManagement';

// The palette the schedule-derived health dot used, so the pipeline table reads as it did. Complete is
// the one addition, and takes the app blue: a second green a shade off moving's would not read as a
// different state on a 0.7rem dot.
export const projectStatusColor: { [k in ProjectManagementProjectStatus]: string } = {
  moving: css.green, complete: css.primaryColor, onHold: css.orange, deferred: css.grey4, canceled: css.red2,
};

const PROJECT_STATUS_TIP = 'pm-project-status-tip';

const BadgeStyled = styled.span`
  display: inline-flex; align-items: center; gap: 0.4rem; white-space: nowrap;
  .dot { display: inline-block; width: 0.7rem; height: 0.7rem; border-radius: 50%; flex: none; }
`;

/** Coloured dot + label for a project's hand-set status; the exception statuses carry the reason as a tooltip. */
export const ProjectStatusBadge = ({ project, className }: { project: ProjectManagementProject; className?: string }) => {
  const status = projectManagementProjectStatus(project);
  const tip = status !== 'moving' && project.statusNote ? project.statusNote : undefined;
  return (
    <BadgeStyled className={className} data-tooltip-id={tip ? PROJECT_STATUS_TIP : undefined} data-tooltip-content={tip}>
      <span className="dot" style={{ background: projectStatusColor[status] }} />
      {projectStatusLabel(status)}
    </BadgeStyled>
  );
};

/** Mount once per page that renders badges — react-tooltip finds anchors by id. */
export const ProjectStatusTooltip = () => <Tooltip id={PROJECT_STATUS_TIP} />;
